import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModuleName } from '@ex/module/shared/enums/ModuleName';
import { GlobalFiltersHelperService } from '../../data-access/services/global-filters-helper.service';
import { debounceTime, switchMap, map, filter, take } from 'rxjs/operators';
import { EssentialObjectService } from '@ex/module/core/services/essential-object.service';
import { Observable } from 'rxjs';
import { HierarchyEntity } from '@ex/module/core/data-models/hierarcy-entity';

@Component({
  selector: 'filter-exports-page',
  templateUrl: './filter-exports-page.component.html',
  styleUrls: ['./filter-exports-page.component.scss']
})
export class FilterExportsPageComponent implements OnInit {
  @Input() language: string;
  @Input() seperatePage: boolean = true;
  @Input() index: number = 3;
  @Input() mode:string = "default"; //partial or default
  @Input() applyGlobalFilters: string;
  @Output() applyGlobalFiltersChange: EventEmitter<boolean> = new EventEmitter();
  ModuleNames = ModuleName;
  filters: any[];
  entities: HierarchyEntity[];

  constructor(private globalFiltersService: GlobalFiltersHelperService, private essentialObjectService: EssentialObjectService) { }

  ngOnInit(): void {
    this.globalFiltersService.filters$.pipe(debounceTime(200), switchMap(filters => {
      return this.globalFiltersService.applyFilters$.pipe(filter(x => x), map(_ => {
        const filterList = filters.filter(x => x.criteria.length).flatMap(x => x.criteria.filter(c => c.value?.length));
        if (filterList?.length)
          this.applyGlobalFiltersChange.emit(true);
        return filterList;
      }));
    })).pipe(take(1)).subscribe(filters => {
      this.filters = filters;
    });

    this.essentialObjectService.essentialObject.pipe(switchMap(({ selectedEntity }) => {
      return this.globalFiltersService.selectedEntities.pipe(debounceTime(200), switchMap(({ nodes }) => {
        return this.globalFiltersService.applyFilters$.pipe(filter(x => x), map(_ => {
          nodes = nodes.reduce((acc, curr) => {
            if (!acc?.length)
              acc = [];
            const groupExists = acc.find(k => k.key == curr.groupKey)
            if (!groupExists) {
              const name = selectedEntity.EntityGroups.find(group => group.groupKey == curr.groupKey)?.name;
              acc.push({ key: curr.groupKey, name, nodes: [curr] })
              return acc;
            }
            acc[acc.indexOf(groupExists)].nodes.push(curr)
            return acc;
          }, [])
          if (nodes?.length)
            this.applyGlobalFiltersChange.emit(true);
          return nodes;
        }))
      }))

    })).pipe(take(1)).subscribe(entities => {
      this.entities = entities;
    });
    ;

  }

}
